export default __webpack_public_path__ + "static/media/Staff of the Shivering Stars.7a0f0f82.jpg";